import { Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient";
import { AuthProvider, AuthGate } from "./context/AuthContext";
import { RequestLinkPage } from "./pages/RequestLinkPage";
import { HomePage } from "./pages/HomePage";
import { AuthPage } from "./pages/AuthPage";
import { GuidedChatPage } from "./pages/GuidedChatPage";
import { CompletionFlowPage } from "./pages/CompletionFlowPage";
import { NewChatRedirect } from "./pages/NewChatRedirect";
import { InsightsPage } from "./pages/InsightsPage";
import { ChatPage } from "./pages/ChatPage";
import { BirdPickerPage } from "./pages/BirdPickerPage";
import { PHProvider } from "../shared/PostHogProvider";
import { usePostHogIdentify } from "./hooks/usePostHogIdentify";
import "../shared/global.css";
import "./app.css";

function AuthenticatedApp() {
  usePostHogIdentify();

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/chat" element={<ChatPage />} />
      <Route path="/insights" element={<InsightsPage />} />
      <Route path="/guided-chat/new" element={<NewChatRedirect />} />
      <Route path="/guided-chat/:id" element={<GuidedChatPage />} />
      <Route
        path="/guided-chat/:id/complete"
        element={<CompletionFlowPage />}
      />
      <Route path="/bird-picker" element={<BirdPickerPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function AppRoot() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <PHProvider>
          <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route
              path="*"
              element={
                <AuthGate fallback={<RequestLinkPage />}>
                  <AuthenticatedApp />
                </AuthGate>
              }
            />
          </Routes>
        </PHProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
